import React, { Fragment } from 'react'
import {
    Box, Flex
} from '@chakra-ui/react'
import DetailsHeader from '../../component/DetailsHeader'
import RightSidebar from '../../component/RightSidebar'
import Timeline from '../../component/Timeline'
import AdditionalDetails from '../../component/AdditionalDetails'





const DisputeDetails = () => {
    return (
        <Fragment>
            <Flex justifyContent={'space-evenly'}>
            <Box p={5} w={'70%'} bgColor='#F5F5F5'>

                <DetailsHeader
                    title={"Dispute ID"}
                    colorScheme={'blackAlpha'}
                    variant={'solid'}
                    invoice={'Create'}
                    menuItems={["Open","In Progress","Resolved","Canceled", "Closed"]}
                    />   
                
                <AdditionalDetails
                    title={"Dispute"}
                    row1={[{"Order ID":`#167846`},{"Tenure ID":`#167846`},{"Settlement ID":`#167846`},{"Return ID":`#167846`}, {"Verification ID": `#167846`}]}
                    row2={[{"Dispute Type":`General query`}]}
                    status={'Resolved'} />

                <Timeline
                text={"Only you and other admin members can see comments"} />
            </Box>

            <Box pr={3} py={3} w={'30%'} bgColor='#F5F5F5'>
                <RightSidebar
                    customerName={'John Doe'}
                    customerGmail={'John@xyz.com'}
                    customerPhone={'9111112225'}
                    shippingArea={'Unkown Area'}
                    shippingCity={'Unkown City'}
                    billingAddress={"Same as shipping address"} />
            </Box>
            </Flex>
        </Fragment>
    )
}

export default DisputeDetails